import Backend from 'backend';
import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {ValidationController, ValidationRules} from "aurelia-validation";
import {FeatureCustomizationProvider} from "../util/feature-customization-provider";
import {UserInfoProvider} from "../util/user-info-provider";

@inject(Backend, Router, ValidationController, FeatureCustomizationProvider, UserInfoProvider)
export class CustomerPortalPurchaseScreen {
  backend;
  router;
  validationController;
  featureCustomizationProvider;
  userInfoProvider;

  confirmationFormModal

  articles;

  constructor(backendFacade, router, validationController, featureCustomizationProvider, userInfoProvider) {
    this.backend = backendFacade;
    this.router = router;
    this.validationController = validationController;
    this.featureCustomizationProvider = featureCustomizationProvider;
    this.userInfoProvider = userInfoProvider;
  }

  activate() {
    return this.refresh();
  }

  refresh() {
    // Which customer does user have access to
    let customerIds = this.featureCustomizationProvider.getCustomerIdsUserHasPortalAccessTo();
    if (customerIds.length > 1) {
      throw new Error('Access to more than one customer is not supported.')
    }
    if (customerIds.length === 0) {
      throw new Error('Access to no customer is not supported.')
    }
    let customerId = customerIds[0];

    return this.backend.CustomerPortalArticleListQueryHandler_handle({customerId: customerId})
      .then(result => {
        this.articles = result.items.map(item => new Article(
          item.articleId,
          item.articleNumber,
          item.articleName,
          item.volume,
          item.abv,
          item.quantityPrCrate,
          item.price,
          item.quantityCrate,
          item.quantityLoose));


        for (const article of this.articles) {
          ValidationRules
            .ensure('quantityCrate')
            .displayName('Antall kasser')
            .satisfies(value => value == null || (Number.isInteger(Number(value)) && value >= 0)) // Number() converts string to number. Otherwise "1" is not an integer.
            .withMessage('Antall kasser må være et positivt heltall')
            .ensure('quantityLoose')
            .displayName('Antall løse')
            .satisfies(value => value == null || (Number.isInteger(Number(value)) && value >= 0)) // Number() converts string to number. Otherwise "1" is not an integer.
            .withMessage('Antall løse må være et positivt heltall')
            .on(article);
      }
      });
  }

  get noLinesHaveAmount() {
    let filter = this.articles.filter(article => article.quantity > 0);
    let b = filter.length == 0;
    return b;
  }

  showconfirmationFormModal() {
    return this.validationController.validate()
      .then(result => {
        if (!result.valid) {
          return;
        }

        this.confirmationFormModal.open();
      });
  }

  get confirmationArticles() {
    return this.articles.filter(article => article.quantity > 0)
  }

  purchase() {
    return this.validationController.validate()
      .then(result => {
        if (!result.valid) {
          return;
        }

        // Register order
        return this.backend.CustomerPortalPurchaseCommandHandler_handle({
          customerId: this.userInfoProvider.getInfo().customerIdForCustomerPortal,
          customersReference: this.customersReference,
          commentFromCustomer: this.commentFromCustomer,
          items: this.articles
            .filter(article => article.quantity > 0)
            .map(article => ({
              articleId: article.articleId,
              quantity: article.quantity,
              price: article.price
            }))
          })
          // Redirect to orders
          .then(result => this.router.navigateToRoute('customer-portal-order-index', {highlightOrderId: result.orderId}));
      });
  }

  clear() {
    return this.refresh()
      .then(() => {
        this.customersReference = null;
        this.commentFromCustomer = null;
      });
  }
}

class Article {
  articleId;
  articleNumber;
  articleName;
  volume;
  abv;
  quantityPrCrate;
  price;
  quantityCrate;
  quantityLoose;

  constructor(articleId, articleNumber, articleName, volume, abv, quantityPrCrate, price, quantityCrate, quantityLoose) {
    this.articleId = articleId;
    this.articleNumber = articleNumber;
    this.articleName = articleName;
    this.volume = volume;
    this.abv = abv;
    this.quantityPrCrate = quantityPrCrate;
    this.price = price;
    this.quantityCrate = quantityCrate;
    this.quantityLoose = quantityLoose;
  }

  get quantity() {
    // Convert to numbers
    let crates = Number(this.quantityCrate || 0);
    let loose = Number(this.quantityLoose || 0);
    let quantityPrCrate = Number(this.quantityPrCrate || 0);
    // Make sure we never calculate with non-integers. We wouldn't want to show a total quantity
    // with decimals while the validation is saying 'not an integer!'
    crates = Number.isInteger(crates) ? crates : Number.NaN;
    loose = Number.isInteger(loose) ? loose : Number.NaN;

    // Calculate total units
    return crates * quantityPrCrate + loose;
  }
}
